export const CANONICAL_LOCAL_ORIGIN = 'http://localhost:3000';

export function isNonCanonicalLocalOrigin(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const host = String(hostname || '').toLowerCase().replace(/^\[|\]$/g, '');
  return host === '127.0.0.1' || host === '::1';
}

export function shouldShowDevOriginNotice() {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }
  if (typeof window === 'undefined') {
    return false;
  }
  return isNonCanonicalLocalOrigin(window.location.hostname);
}
